// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__Kwplm","consentsList":"PatientConsents_consentsList__1Ks1B","consentsListEmpty":"PatientConsents_consentsListEmpty__CEyPx"};